// OpenTelemetry must be imported first so its instrumentations patch
// XMLHttpRequest/fetch and hook the document-load timings before anything else
// in the app runs. See setup/otel/telemetry.ts.
import initTelemetry from './setup/otel/telemetry'
import React from 'react'
import ReactDOM from 'react-dom'
// Redux
// https://github.com/rt2zz/redux-persist
import {PersistGate} from 'redux-persist/integration/react'
import {Provider} from 'react-redux'
import * as _redux from './setup'
import store, {persistor} from './setup/redux/Store'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import '@uiw/react-textarea-code-editor/dist.css'
import '@progress/kendo-theme-bootstrap/dist/all.css'
import 'react-toastify/dist/ReactToastify.css'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import './app/modules/dashboard/Typography.scss'
import * as am5 from '@amcharts/amcharts5'
//import '@progress/kendo-theme-default/dist/all.css'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
// No-op unless REACT_APP_OTEL_EXPORT_ENABLED === 'true'.
initTelemetry()

_redux.setupAxios(axios, store)

Chart.register(...registerables)

const queryClient = new QueryClient()
const key = process.env.REACT_APP_AM_CHART5_LICENCE_KEY
key && am5.addLicense(key)

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <MetronicI18nProvider>
      <Provider store={store}>
        {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
        <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
          <AppRoutes />
        </PersistGate>
      </Provider>
    </MetronicI18nProvider>
  </QueryClientProvider>,

  document.getElementById('root')
)
